import webSocketInstance from "_lib/request/socket-standard";

export function enterChannel(args) {
  let url = "chatroom/channel/enter_channel";
  return webSocketInstance.wsRequest(url, args);
}
// 进入房间和进入频道一样接口，根据加不加roomid区分，这里业务上做一下区分
export function enterRoom(args) {
  let url = "chatroom/channel/enter_channel";
  return webSocketInstance.wsRequest(url, args);
}

export function exitChannel(args) {
  let url = "chatroom/channel/exit_channel";
  return webSocketInstance.wsRequest(url, args);
}

// 抢麦ws接口
export function controlAudio(args) {
  let url = "chatroom/channel/control_audio";
  return webSocketInstance.wsRequest(url, args);
}
